// Define types for the family tree application

// Gender options
export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  NON_BINARY = 'non-binary',
  CUSTOM = 'custom'
}

// Relationship types
export enum RelationshipType {
  MARRIED = 'married',
  DIVORCED = 'divorced',
  COHABITING = 'cohabiting',
  SEPARATED = 'separated',
  ENGAGED = 'engaged',
  DATING = 'dating',
  UNKNOWN = 'unknown'
}

// Parental relationship types
export enum ParentalType {
  BIOLOGICAL = 'biological',
  ADOPTIVE = 'adoptive',
  STEP = 'step',
  GUARDIAN = 'guardian'
}

// Emotional relationship tags (for genograms)
export enum EmotionalTag {
  CONFLICT = 'conflict',
  CLOSE = 'close',
  DISTANT = 'distant',
  ABUSIVE = 'abusive',
  NORMAL = 'normal'
}

// Individual (Person) interface
export interface Individual {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  gender: Gender;
  birthDate?: string;
  deathDate?: string;
  birthPlace?: string;
  deathPlace?: string;
  occupation?: string;
  education?: string;
  photos?: string[]; // URLs or base64 encoded images
  medicalHistory?: string;
  notes?: string;
  tags?: string[];
  isDeceased?: boolean;
}

// Family Unit interface
export interface FamilyUnit {
  id: string;
  partners: [string, string]; // IDs of the two individuals
  relationshipType: RelationshipType;
  marriageDate?: string;
  divorceDate?: string;
  notes?: string;
  children?: string[]; // IDs of children
}

// Child relationship interface
export interface ChildRelationship {
  id: string;
  childId: string;
  familyUnitId: string;
  parentalType: ParentalType;
  notes?: string;
}

// Emotional relationship interface (for genograms)
export interface EmotionalRelationship {
  id: string;
  fromId: string;
  toId: string;
  tag: EmotionalTag;
  notes?: string;
}

// User interface for authentication
export interface User {
  username: string;
  password: string;
  isAdmin: boolean;
}

// Family Tree interface
export interface FamilyTree {
  id: string;
  name: string;
  description?: string;
  individuals: Individual[];
  familyUnits: FamilyUnit[];
  childRelationships: ChildRelationship[];
  emotionalRelationships: EmotionalRelationship[];
  createdAt: string;
  updatedAt: string;
}
